import Image from "next/image";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Button from "@Front/Components/DesignSystem/Button";
import idNoteLogo from "@Assets/Icons/id-note-logo.svg";
import classes from "../classes.module.scss";

type StepEmailNotarySectionProps = {
	title: string;
	cta: string;
	subscribeCta: string;
	onClick: () => void | Promise<void>;
};

export default function StepEmailNotarySection({
	title,
	cta,
	subscribeCta,
	onClick,
}: StepEmailNotarySectionProps): React.JSX.Element {
	return (
		<div className={classes["section"]}>
			<Typography typo={ETypo.TITLE_H4} color={ETypoColor.TEXT_ACCENT} className={classes["section-title-emphasis"]}>
				{title}
			</Typography>
			<div className={classes["notary-actions"]}>
				<Button onClick={onClick} rightIcon={<Image alt="id-not-logo" src={idNoteLogo} />}>
					{cta}
				</Button>
				<Button
					onClick={onClick}
					className={classes["idnot-subscribe-button"]}
					rightIcon={<Image alt="id-not-logo" src={idNoteLogo} />}>
					{subscribeCta}
				</Button>
			</div>
		</div>
	);
}
